var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1646_9053",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16.1,
    height: 16,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1646_9053)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1646_9053",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: -2,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1646_9053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3125 15L11.0625 13.8333C10.8681 13.7639 10.684 13.6806 10.5104 13.5833C10.3368 13.4861 10.1736 13.375 10.0208 13.25L8.875 13.6042L8.20833 12.4583L9.0625 11.625C9.00694 11.4306 8.98264 11.2292 8.98958 11.0208C8.99653 10.8125 9.02083 10.6111 9.0625 10.4167L8.20833 9.60417L8.875 8.4375L10 8.77083C10.1528 8.63194 10.3194 8.51042 10.5 8.40625C10.6806 8.30208 10.8681 8.22222 11.0625 8.16667L11.3333 7H12.6667L12.9375 8.16667C13.1319 8.23611 13.3194 8.31944 13.5 8.41667C13.6806 8.51389 13.8472 8.63194 14 8.77083L15.125 8.45833L15.7917 9.60417L14.9583 10.3958C14.9861 10.6042 15 10.8125 15 11.0208C15 11.2292 14.9792 11.4306 14.9375 11.625L15.7917 12.4375L15.125 13.5833L13.9792 13.25C13.8264 13.375 13.6632 13.4896 13.4896 13.5938C13.316 13.6979 13.1319 13.7778 12.9375 13.8333L12.6458 15H11.3125ZM0 14V12.0833C0 11.7222 0.0868056 11.3924 0.260417 11.0938C0.434028 10.7951 0.673611 10.5556 0.979167 10.375C1.74306 9.93056 2.54861 9.59028 3.39583 9.35417C4.24306 9.11806 5.11111 9 6 9C6.15278 9 6.29514 9.00347 6.42708 9.01042C6.55903 9.01736 6.70139 9.02778 6.85417 9.04167C6.54861 9.80556 6.44444 10.6493 6.54167 11.5729C6.63889 12.4965 6.92361 13.3056 7.39583 14H0ZM12 12.5C12.4167 12.5 12.7708 12.3542 13.0625 12.0625C13.3542 11.7708 13.5 11.4167 13.5 11C13.5 10.5833 13.3542 10.2292 13.0625 9.9375C12.7708 9.64583 12.4167 9.5 12 9.5C11.5833 9.5 11.2292 9.64583 10.9375 9.9375C10.6458 10.2292 10.5 10.5833 10.5 11C10.5 11.4167 10.6458 11.7708 10.9375 12.0625C11.2292 12.3542 11.5833 12.5 12 12.5ZM6 8C5.16667 8 4.45833 7.70833 3.875 7.125C3.29167 6.54167 3 5.83333 3 5C3 4.16667 3.29167 3.45833 3.875 2.875C4.45833 2.29167 5.16667 2 6 2C6.83333 2 7.54167 2.29167 8.125 2.875C8.70833 3.45833 9 4.16667 9 5C9 5.83333 8.70833 6.54167 8.125 7.125C7.54167 7.70833 6.83333 8 6 8Z",
    fill: "#1A446F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageIcon);
export default __webpack_public_path__ + "static/media/ManageIcon.be2696573398306b762998916eb1f7d4.svg";
export { ForwardRef as ReactComponent };